import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=7a022f73&scoped=true"
import script from "./NavigationItem.vue?vue&type=script&lang=ts"
export * from "./NavigationItem.vue?vue&type=script&lang=ts"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=7a022f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a022f73",
  null
  
)

export default component.exports